import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_2 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
}
const _hoisted_3 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-1 text-xs text-red-500"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = ["disabled"]

import { reactive, computed, watch } from 'vue'
import Modal from '@/components/layout/Modal.vue'

import type { Position } from '@/services/positionService'

interface Draft {
  firstName: string
  lastName: string
  username: string
  dateOfBirth: string
  gender: string
  address: string
  city: string
  state: string
  zipcode: string
  phone: string
  email: string
  positionId: number | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePersonalModal',
  props: {
    isOpen: { type: Boolean },
    draft: {},
    loading: { type: Boolean },
    positions: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Create a local reactive copy of the draft
const localDraft = reactive<Draft>({ ...props.draft })

// When modal opens, re-initialize ALL fields from props to ensure cancel reverts to original values
// This is the ONLY time we sync from parent to child - prevents field shifting during editing
watch(() => props.isOpen, (isOpen) => {
  if (isOpen) {
    localDraft.firstName = props.draft.firstName
    localDraft.lastName = props.draft.lastName
    localDraft.username = props.draft.username
    localDraft.dateOfBirth = props.draft.dateOfBirth
    localDraft.gender = props.draft.gender
    localDraft.address = props.draft.address
    localDraft.city = props.draft.city
    localDraft.state = props.draft.state
    localDraft.zipcode = props.draft.zipcode
    localDraft.phone = props.draft.phone
    localDraft.email = props.draft.email
    localDraft.positionId = props.draft.positionId
  }
})

const requiredError = computed(() => {
  if (!localDraft.firstName) {
    return 'First name is required'
  }
  else if (!localDraft.lastName) {
    return 'Last name is required'
  }
  else if (!localDraft.username) {
    return 'Username is required'
  }
  return ''
})

// Username validation: check if username contains spaces
const usernameError = computed(() => {
  if (localDraft.username && localDraft.username.includes(' ')) {
    return 'Username cannot contain spaces'
  }
  return ''
})

const isValid = computed(() => {
  return !usernameError.value
})

const handleSave = () => {
  if (isValid.value) {
    emit('save', { ...localDraft })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "model-value": __props.isOpen,
    title: "Edit Personal Details",
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center rounded-xl border bg-danger px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center rounded-xl bg-primary hover:bg-secondary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:brightness-110 transition disabled:cursor-not-allowed disabled:opacity-60",
        disabled: __props.loading || !isValid.value,
        onClick: handleSave
      }, " Save ", 8, _hoisted_7)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, [
            _createTextVNode("First Name "),
            _createElementVNode("span", { class: "text-danger" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localDraft.firstName) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60",
            required: ""
          }, null, 512), [
            [_vModelText, localDraft.firstName]
          ]),
          (!localDraft.firstName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(requiredError.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, [
            _createTextVNode("Last Name "),
            _createElementVNode("span", { class: "text-danger" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localDraft.lastName) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60",
            required: ""
          }, null, 512), [
            [_vModelText, localDraft.lastName]
          ]),
          (!localDraft.lastName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(requiredError.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Username ", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localDraft.username) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60",
            required: ""
          }, null, 512), [
            [_vModelText, localDraft.username]
          ]),
          (!localDraft.username)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(requiredError.value), 1))
            : _createCommentVNode("", true),
          (usernameError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(usernameError.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Gender", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localDraft.gender) = $event)),
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("option", { value: "" }, "Select", -1),
            _createElementVNode("option", { value: "Male" }, "Male", -1),
            _createElementVNode("option", { value: "Female" }, "Female", -1),
            _createElementVNode("option", { value: "Prefer not to say" }, "Prefer not to say", -1)
          ]))], 512), [
            [_vModelSelect, localDraft.gender]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Phone", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localDraft.phone) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, null, 512), [
            [_vModelText, localDraft.phone]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Date of Birth", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localDraft.dateOfBirth) = $event)),
            type: "date",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, null, 512), [
            [_vModelText, localDraft.dateOfBirth]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Address", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localDraft.address) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, null, 512), [
            [_vModelText, localDraft.address]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Position", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((localDraft.positionId) = $event)),
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, [
            _cache[21] || (_cache[21] = _createElementVNode("option", { value: null }, "Select position", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.positions, (pos) => {
              return (_openBlock(), _createElementBlock("option", {
                key: pos.id,
                value: pos.id
              }, _toDisplayString(pos.name), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, localDraft.positionId]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "City", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((localDraft.city) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, null, 512), [
            [_vModelText, localDraft.city]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "State", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((localDraft.state) = $event)),
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, [...(_cache[24] || (_cache[24] = [
            _createElementVNode("option", { value: "" }, "Select state", -1),
            _createElementVNode("option", { value: "Alabama" }, "Alabama", -1),
            _createElementVNode("option", { value: "Alaska" }, "Alaska", -1),
            _createElementVNode("option", { value: "Arizona" }, "Arizona", -1),
            _createElementVNode("option", { value: "Arkansas" }, "Arkansas", -1),
            _createElementVNode("option", { value: "California" }, "California", -1),
            _createElementVNode("option", { value: "Colorado" }, "Colorado", -1),
            _createElementVNode("option", { value: "Connecticut" }, "Connecticut", -1),
            _createElementVNode("option", { value: "Delaware" }, "Delaware", -1),
            _createElementVNode("option", { value: "Florida" }, "Florida", -1),
            _createElementVNode("option", { value: "Georgia" }, "Georgia", -1),
            _createElementVNode("option", { value: "Hawaii" }, "Hawaii", -1),
            _createElementVNode("option", { value: "Idaho" }, "Idaho", -1),
            _createElementVNode("option", { value: "Illinois" }, "Illinois", -1),
            _createElementVNode("option", { value: "Indiana" }, "Indiana", -1),
            _createElementVNode("option", { value: "Iowa" }, "Iowa", -1),
            _createElementVNode("option", { value: "Kansas" }, "Kansas", -1),
            _createElementVNode("option", { value: "Kentucky" }, "Kentucky", -1),
            _createElementVNode("option", { value: "Louisiana" }, "Louisiana", -1),
            _createElementVNode("option", { value: "Maine" }, "Maine", -1),
            _createElementVNode("option", { value: "Maryland" }, "Maryland", -1),
            _createElementVNode("option", { value: "Massachusetts" }, "Massachusetts", -1),
            _createElementVNode("option", { value: "Michigan" }, "Michigan", -1),
            _createElementVNode("option", { value: "Minnesota" }, "Minnesota", -1),
            _createElementVNode("option", { value: "Mississippi" }, "Mississippi", -1),
            _createElementVNode("option", { value: "Missouri" }, "Missouri", -1),
            _createElementVNode("option", { value: "Montana" }, "Montana", -1),
            _createElementVNode("option", { value: "Nebraska" }, "Nebraska", -1),
            _createElementVNode("option", { value: "Nevada" }, "Nevada", -1),
            _createElementVNode("option", { value: "New Hampshire" }, "New Hampshire", -1),
            _createElementVNode("option", { value: "New Jersey" }, "New Jersey", -1),
            _createElementVNode("option", { value: "New Mexico" }, "New Mexico", -1),
            _createElementVNode("option", { value: "New York" }, "New York", -1),
            _createElementVNode("option", { value: "North Carolina" }, "North Carolina", -1),
            _createElementVNode("option", { value: "North Dakota" }, "North Dakota", -1),
            _createElementVNode("option", { value: "Ohio" }, "Ohio", -1),
            _createElementVNode("option", { value: "Oklahoma" }, "Oklahoma", -1),
            _createElementVNode("option", { value: "Oregon" }, "Oregon", -1),
            _createElementVNode("option", { value: "Pennsylvania" }, "Pennsylvania", -1),
            _createElementVNode("option", { value: "Rhode Island" }, "Rhode Island", -1),
            _createElementVNode("option", { value: "South Carolina" }, "South Carolina", -1),
            _createElementVNode("option", { value: "South Dakota" }, "South Dakota", -1),
            _createElementVNode("option", { value: "Tennessee" }, "Tennessee", -1),
            _createElementVNode("option", { value: "Texas" }, "Texas", -1),
            _createElementVNode("option", { value: "Utah" }, "Utah", -1),
            _createElementVNode("option", { value: "Vermont" }, "Vermont", -1),
            _createElementVNode("option", { value: "Virginia" }, "Virginia", -1),
            _createElementVNode("option", { value: "Washington" }, "Washington", -1),
            _createElementVNode("option", { value: "West Virginia" }, "West Virginia", -1),
            _createElementVNode("option", { value: "Wisconsin" }, "Wisconsin", -1),
            _createElementVNode("option", { value: "Wyoming" }, "Wyoming", -1)
          ]))], 512), [
            [_vModelSelect, localDraft.state]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[26] || (_cache[26] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Zip Code", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((localDraft.zipcode) = $event)),
            type: "text",
            class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
          }, null, 512), [
            [_vModelText, localDraft.zipcode]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})